import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Grid,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    TextField,
    Box,
    InputAdornment,
    Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';
import categoryService from "../../../../services/categoryService";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getbrands } from "../../../../redux/actions/BrandAction";

const AddCategory = ({ open, handleClose, handleAddAll }) => {
    const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
    const authUserId = useSelector((state) => state?.auth?.user?.id);

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [categorySearchTerm, setCategorySearchTerm] = useState("");
    const [selectedBrand, setSelectedBrand] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    
    const fetchCategories = async () => {
        try {
            const fetchedCategories =
                await categoryService.getCategoriesApiForDropdown(
                    token,
                    1,
                    "",
                    authUserId
                );
            setCategories(fetchedCategories?.data?.data?.data || []);
        } catch (error) {
            console.error("Kategoriler alınırken bir hata oluştu:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleChange = (event, newValue) => {
        setSelectedCategory(newValue ? newValue.id : "");
    };
    
    const handleCategoryInputChange = (event, newInputValue) => {
        setCategorySearchTerm(newInputValue);
    };
    
    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue ? newValue.id : "");
    };
    
    const handleInputChange = (event, newInputValue) => {
        setSearchTerm(newInputValue);
    };
    
    const handleSave = () => {
        handleAddAll(selectedCategory, selectedBrand);
        handleClose();
    };

    const [brandsData, setBrandsData] = useState([]);
    
    useEffect(() => {
        if (authUserId && token) {
            setLoading(true);
            dispatch(getbrands(authUserId, token, 1, searchTerm))
                .then(() => setLoading(false))
                .catch(() => setLoading(false));
        }
    }, [authUserId, token, searchTerm, dispatch]);

    const brands = useSelector(state => state?.brands);
    
    useEffect(() => {
        if (brands?.brands?.data) {
            setBrandsData(brands.brands.data);
        }
    }, [brands]);

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle
                sx={{
                    color: "black",
                    fontWeight: "bold",
                    textAlign: "center",
                    padding: 3,
                    marginBottom: 1,
                    position: "relative",
                }}
            >
                Kategori ve Marka seç
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={3} sx={{ marginTop: 1 }}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <Autocomplete
                                id="category-select"
                                options={categories || []}
                                getOptionLabel={(option) => option.name}
                                onChange={handleChange}
                                onInputChange={handleCategoryInputChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Kategori"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </FormControl>

                        <FormControl fullWidth sx={{marginTop:2}}>
                            <Autocomplete
                                id="brand-select"
                                options={brandsData || []}
                                getOptionLabel={(option) => option.name}
                                onChange={handleBrandChange}
                                onInputChange={handleInputChange}
                                loading={loading}
                                loadingText="Markalar yükleniyor..."
                                noOptionsText="Marka bulunamadı"
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Marka"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ padding: 2, }}>
                <Button 
                variant="contained" 
                sx={{ borderRadius: 2 }}
                 color="primary" 
                 onClick={handleSave}
                 disabled={selectedBrand==""||selectedCategory==""}>
                    Kaydet
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddCategory;
